import CapsulaTemplate from 'templates/Capsula';

export default function Capsula() {
  return <CapsulaTemplate />;
}
